import React from "react";

function AssigmentTile() {
  return (
    <nav
      class="doctolib-widget"
      id="doctolib-nav"
      aria-label="Doctolib Schnellzugriff">
      <a href="#maincontent" class="skip-link">
        Zum Hauptinhalt springen
      </a>
      <img
        src="https://www.doctolib.de/external_button/doctolib-white-transparent.png"
        alt="Doctolib Logo"
      />
      <a
        href="https://www.doctolib.de/praxis/falkenberg-elster/epikur-gmbh?utm_campaign=website-button&amp;utm_source=epikur-gmbh-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=epikur-gmbh"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Termin über Doctolib buchen">
        Termin
      </a>
      <a
        href="https://www.doctolib.de/praxis/falkenberg-elster/epikur-gmbh/patient-request?utm_campaign=website-button&amp;utm_source=epikur-gmbh/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=epikur-gmbh/patient-request"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Nachricht an Praxis über Doctolib senden">
        Nachricht
      </a>
    </nav>
  );
}

export default AssigmentTile;
